module.exports = __webpack_public_path__ + "static/media/arrow-left-purple.156a14c0.svg";